import * as React from "react";
import { MapPin, Clock, Car } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { Link } from "@/components/common/Link";
const hoursData = [{
  days: "Friday Reception",
  times: "6:00 PM – 10:00 PM"
}, {
  days: "Saturday Gala",
  times: "7:00 PM – 12:00 AM"
}];
export default function WhereToMeet() {
  return <section data-section-id="226210" id="where-to-meet" className="bg-background text-foreground py-24 sm:py-32 relative overflow-hidden border-y border-primary/20">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary/10 via-background to-background pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          
          {}
          <div className="relative aspect-square sm:aspect-[4/3] lg:aspect-square w-full rounded-md overflow-hidden bg-secondary/40 border border-primary/30 shadow-2xl">
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/skyline_high_reunion_map.png" alt="Map showing Skyline High Reunion venue in the city center" className="w-full h-full object-cover opacity-70 grayscale-[30%]" />
            
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent" />

            {}
            <div className="absolute top-[45%] left-[50%] -translate-x-1/2 -translate-y-1/2">
              <div className="relative flex items-center justify-center">
                {}
                <div className="absolute size-12 bg-primary/30 rounded-lg animate-ping" />
                {}
                <div className="relative size-4 bg-primary rounded-md shadow-lg shadow-primary/50 border-2 border-background" />
                
                {}
                <div className="absolute top-full mt-3 bg-card/95 backdrop-blur-md border border-primary/30 text-card-foreground px-4 py-2 rounded-md shadow-xl whitespace-nowrap">
                  <p className="font-default font-bold text-sm tracking-widest uppercase text-primary">The Grand Ballroom</p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col justify-center">
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="h-px w-8 bg-primary/50" />
              <span className="font-default text-xs font-semibold tracking-widest uppercase text-primary">Event Venue</span>
            </div>
            
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-8">
              Where to <br className="hidden sm:block" />
              <span className="text-primary italic">Meet Again</span>
            </h2>

            <div className="space-y-10">
              {}
              <div className="flex items-start gap-4">
                <div className="mt-1 bg-primary/10 p-3 rounded-md text-primary shrink-0 border border-primary/20">
                  <MapPin className="size-5" />
                </div>
                <div>
                  <h3 className="font-default text-xl font-semibold mb-2 text-foreground">The Heritage Plaza</h3>
                  <p className="font-sans text-muted-foreground leading-relaxed">
                    1200 Skyline Boulevard, Downtown<br />
                    Skyline High Class of 2005
                  </p>
                </div>
              </div>

              {}
              <div className="flex items-start gap-4">
                <div className="mt-1 bg-primary/10 p-3 rounded-md text-primary shrink-0 border border-primary/20">
                  <Clock className="size-5" />
                </div>
                <div className="w-full">
                  <h3 className="font-default text-xl font-semibold mb-4 text-foreground">Reunion Schedule</h3>
                  <Table className="w-full">
                    <TableBody>
                      {hoursData.map((row, i) => <TableRow key={i} data-index={i} className="border-b border-primary/10 hover:bg-transparent">
                          <TableCell className="font-sans text-muted-foreground py-4 pl-0 border-none">
                            {row.days}
                          </TableCell>
                          <TableCell className="text-right font-sans text-foreground py-4 pr-0 font-semibold border-none">
                            {row.times}
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
              </div>

              {}
              <div className="pt-6 border-t border-primary/20">
                <p className="font-sans text-sm text-muted-foreground mb-6">
                  Need a place to stay? We have partnered with local hotels to offer exclusive alumni discounts for our 20-year celebration.
                </p>
                <Link to="/TheWeekendAgendaPage">
                  <Button size="lg" className="w-full sm:w-auto bg-gradient-to-r from-primary to-amber-600 text-primary-foreground hover:opacity-90 rounded-md tracking-widest uppercase text-xs font-bold h-14 px-8 shadow-lg shadow-primary/20">
                    <Car className="mr-3 size-4" />
                    Travel Guide
                  </Button>
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}